import { createAction, props } from "@ngrx/store";

export const updateState = createAction(
    '[Valuation Process Page - V2 / Valuation Tab] Update DCF State',
    props<{
        gross_market_rent: number | null, 
        opex: number | null,
        void_period_allowance: number | null,
        holding_period: number | null 
        terminal_capital_rate: number | null,
        annual_growth_rate: number | null,
        annual_opex_rate: number | null,
        disposal_cost_on_exit: number | null,
        discount_rate: number | null,
        value: number | null,
        file_name: string | null,
        file_path: string | null
    }>()
)